import React, { useEffect, useState } from "react";
import image7 from "../../Assets/Images/seekjob/ladyimg.png";
import image8 from "../../Assets/Images/seekjob/laptopscren 1.png";
import image9 from "../../Assets/Images/seekjob/gdrimg.png";

function SeeAction({ onRequestDemo }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Tailwind 'md' breakpoint
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="SeeItIn" className="tw-relative tw-z-10 tw-min-h-screen tw-text-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-16 tw-px-4 sm:tw-px-6 lg:tw-px-8">
      {/* Section Title */}
      <h2 className="tw-text-[36px] sm:tw-text-[66px] tw-font-semibold tw-mb-16 tw-text-center">
        See it in action.
      </h2>

      {/* Main Content Area */}
      <div className="tw-relative tw-w-full tw-max-w-7xl tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-center lg:tw-space-x-12">
        {/* Left Side */}
        <div className="tw-flex tw-flex-col tw-items-center tw-text-center lg:tw-text-left lg:tw-absolute lg:tw-left-[-30px] lg:tw-top-1/2 lg:-tw-translate-y-1/2 tw-mb-12 lg:tw-mb-0 lg:tw-w-1/4">
          <div className="tw-relative tw-w-[220px] sm:tw-w-[295px] tw-h-[300px] sm:tw-h-[414px] tw-rounded-full tw-overflow-hidden tw-mb-4 tw-border-2 tw-border-blue-500 tw-bottom-12 sm:tw--right-[-1rem]">
            <img
              src={image7}
              alt="Alysha"
              className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/192x192/000000/FFFFFF?text=Alysha";
              }}
            />
          </div>
          <p className="tw-text-base sm:tw-text-lg tw-font-semibold tw-mt-[-40px] sm:tw-mt-[-79px]">
            Watch how Alysha landed 3 interviews in one week
          </p>
        </div>

        {/* Center Laptop */}
        <div
          className="tw-relative tw-z-10 tw-mb-12 lg:tw-mb-0"
          style={isMobile ? { width: "384px", left: "-5px" } : { width: "900px", left: "-38px" }}
        >
          {/* Laptop image */}
          <img
            src={image8}
            alt="Laptop Mockup"
            className="tw-w-full tw-h-auto tw-rounded-lg"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://placehold.co/1200x700/1a202c/ffffff?text=Laptop+Mockup";
            }}
          />

          {/* Video overlay (inside laptop screen) */}
          <div
            className="tw-absolute tw-top-[1%] tw-left-[13%] tw-w-[74%] tw-h-[85%] tw-rounded-md tw-overflow-hidden"
          >
            <iframe
              className="tw-w-full tw-h-full"
              src="https://www.youtube.com/embed/NpeXzBgUqSY?rel=0&autoplay=1&mute=1&loop=1&playlist=NpeXzBgUqSY"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>


        {/* Right Side */}
        <div className="tw-flex tw-flex-col tw-items-center tw-text-center lg:tw-text-right lg:tw-absolute lg:tw-right-[-25px] lg:tw-top-1/2 lg:-tw-translate-y-1/2 lg:tw-w-1/4">
          <div className="tw-relative tw-w-[200px] sm:tw-w-[242px] tw-h-[300px] sm:tw-h-[394px] tw-mt-[-60px] sm:tw-mt-[-137px] sm:tw-ml-[-90px] tw-rounded-full tw-overflow-hidden tw-mb-4 tw-border-2 tw-border-blue-500" style={{
            bottom: window.innerWidth < 768 ? "-88px" : undefined,
          }}>
            <img
              src={image9}
              alt="State University"
              className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/192x192/000000/FFFFFF?text=University";
              }}
            />
          </div>
          <p className="tw-text-base sm:tw-text-lg tw-font-semibold tw-mt-[-277px] sm:tw-mt-[-456px]">
            See how State University boosted student placement by 40%
          </p>
        </div>
      </div>

      {/* Buttons */}
      <div className="tw-mt-[339px] sm:tw-mt-[80px] tw-text-[16px] tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-y-0 sm:tw-space-x-4">

        <button onClick={onRequestDemo} className="tw-inline-block tw-bg-gradient-to-r tw-from-[#0843FE] tw-to-[#4995FB] tw-text-white tw-font-medium tw-py-3 tw-px-8 tw-rounded-md tw-transition tw-duration-300 tw-ease-in-out" style={{ border: "none" }}>
          Request Demo
        </button>
        <a
          href="https://youtu.be/NpeXzBgUqSY"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="tw-text-[16px] tw-bg-white tw-text-[#114efe] tw-border tw-border-white tw-font-semibold tw-py-3 tw-px-8 tw-rounded-lg tw-transition tw-duration-300">
            Watch Video
          </button>
        </a>

      </div>
    </div>
  );
}

export default SeeAction;
